module.exports = __webpack_public_path__ + "img/exo-ape-2x_e91d9d3caaf9be003a755eccd3b1add9.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/exo-ape-2x.jpg
// module id = 294
// module chunks = 0